import produce from "immer";
import validateStep from "./validateStep";

import { WritableDraft } from "immer/dist/internal";
import { SendDelay } from "@dashboard-v3/api";
import { State } from "../types";

export type UpdateSendDelay = {
  type: "updateSendDelay";
  payload: Payload;
};

type Payload = Partial<{
  expiration: SendDelay["expiration"];
  senderNotification: SendDelay["senderNotification"];
  doneNotification: SendDelay["doneNotification"];
  rejectOnExpiration: SendDelay["rejectOnExpiration"];
  reminderSenderNotification: SendDelay["reminderSenderNotification"];
  allowStop: SendDelay["allowStop"];
  reminder: SendDelay["reminder"];
}>;

export function updateSendDelay(state: State, payload: Payload) {
  return produce(state, draft => {
    if ("expiration" in payload) {
      updateExpiration(draft, payload);
    }

    if ("senderNotification" in payload) {
      updateSenderNotification(draft, payload);
    }

    if ("doneNotification" in payload) {
      updateDoneNotification(draft, payload);
    }

    if ("rejectOnExpiration" in payload) {
      draft.rule.sendDelay.rejectOnExpiration = payload.rejectOnExpiration;
    }

    if ("allowStop" in payload) {
      draft.rule.sendDelay.allowStop = payload.allowStop;
    }

    if ("reminderSenderNotification" in payload) {
      draft.steps.sendDelay.done = false;
      if (payload.reminderSenderNotification === null) {
        delete draft.rule.sendDelay.reminderSenderNotification;
      } else {
        draft.rule.sendDelay.reminderSenderNotification =
          payload.reminderSenderNotification;
      }
    }

    if ("reminder" in payload) {
      draft.steps.sendDelay.done = false;
      if (payload.reminder === null) {
        delete draft.rule.sendDelay.reminder;
      } else {
        draft.rule.sendDelay.reminder = payload.reminder;
      }
    }

    validateStep("sendDelay", draft);
  });
}

function updateExpiration(draft: WritableDraft<State>, payload: Payload) {
  const type = payload.expiration?.type;
  const value = payload.expiration?.value;

  const sendDelayExpiration = draft.rule.sendDelay.expiration;

  if (type === "MINUTES" && Boolean(draft.rule.sendDelay.reminder)) {
    delete draft.rule.sendDelay.reminder;
    delete draft.rule.sendDelay.reminderSenderNotification;
  }

  if (type) {
    sendDelayExpiration.type = type;
    draft.steps.sendDelay.done = false;
  }

  if (value !== undefined) {
    sendDelayExpiration.value = value;
    if (isNaN(value)) {
      sendDelayExpiration.value = null;
    }
    draft.steps.sendDelay.done = false;
  }
}

function updateSenderNotification(
  draft: WritableDraft<State>,
  payload: Payload
) {
  const sendDelay = draft.rule.sendDelay;

  draft.steps.sendDelay.done = false;

  if (payload.senderNotification === null) {
    return delete sendDelay.senderNotification;
  }

  sendDelay.senderNotification = {
    ...payload.senderNotification,
  };
}

function updateDoneNotification(draft: WritableDraft<State>, payload: Payload) {
  draft.steps.sendDelay.done = false;

  if (payload.doneNotification === null) {
    return delete draft.rule.sendDelay.doneNotification;
  }

  draft.rule.sendDelay.doneNotification = payload.doneNotification;
}
